var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "extraInfo" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "contact" }, [
          _vm.DialogQuestion.contactName != null
            ? _c("span", [
                _vm._v("联系人：" + _vm._s(_vm.DialogQuestion.contactName))
              ])
            : _vm._e(),
          _vm.DialogQuestion.contactName == null
            ? _c("span", [_vm._v("联系人：无")])
            : _vm._e(),
          _vm.DialogQuestion.contactInfo != null
            ? _c("span", [
                _vm._v(
                  " (联系方式：" + _vm._s(_vm.DialogQuestion.contactInfo) + ")"
                )
              ])
            : _vm._e(),
          _vm.DialogQuestion.contactInfo == null
            ? _c("span", [_vm._v(" (联系方式：无)")])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "right" }, [
        _c(
          "div",
          { staticClass: "readcount", staticStyle: { "text-align": "right" } },
          [_vm._v(_vm._s(_vm.DialogQuestion.viewcount) + "次阅读")]
        ),
        _c("div", { staticClass: "updatetime" }, [
          _vm._v(_vm._s(_vm.DialogQuestion.modifiedTime) + " 更新")
        ])
      ])
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "keypoint" }, [
        _c("div", [
          _vm._v(" 【解答要点】"),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.DialogQuestion.answer) }
          })
        ])
      ]),
      _c("div", { staticClass: "analysis-wrapper" }, [
        _c("div", { staticClass: "anlysis" }, [
          _c("div", [
            _vm._v(" 【法律分析】"),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.DialogQuestion.legalAnalysis) }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "more-quesions" }, [
        _c("div", { staticClass: "relatedQ-title" }, [
          _vm.relatedDialogQuestion.length > 0
            ? _c("span", [
                _c("span", { staticClass: "icon relatedQuestion" }),
                _vm._v("关联问题")
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "relatedQ-wrapper" },
          _vm._l(_vm.relatedDialogQuestion, function(question, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "relatedQ",
                attrs: { title: question.question },
                on: {
                  click: function($event) {
                    return _vm.showRelatedQuestionModal(question)
                  }
                }
              },
              [_vm._v(" " + _vm._s(question.question) + " ")]
            )
          }),
          0
        )
      ]),
      _c(
        "div",
        { staticClass: "keywords" },
        [
          _vm._l(_vm.DialogQuestion.regulationInternal.slice(0, 2), function(
            law,
            index
          ) {
            return _c("span", { key: index, staticClass: "ghost red" }, [
              _vm._v(_vm._s(law))
            ])
          }),
          _vm._l(_vm.DialogQuestion.regulationExternal.slice(0, 2), function(
            law,
            index
          ) {
            return _c("span", { key: index, staticClass: "ghost yellow2" }, [
              _vm._v(_vm._s(law))
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }